import { put, call } from 'redux-saga/effects';
import apigeeDataService from '../../services/appieigeData.service';
import { constants } from './../../constants';

import { 
  getExamSeriesSuccess,
  getExamSeriesError,
  toggleAlertShowStatus} from '../actions';


export default function * getExamSeriesList () {
  try {
    const res = yield call([apigeeDataService, 'getExamseries'])

    //making sure redux store will update if api save is successful
    yield put(getExamSeriesSuccess(res.data.Sessions));
  } catch (error) {
    yield put(toggleAlertShowStatus({
      showAlert: true,
      alertVarient:'danger',
      alertMessage: constants.APP_MESSAGE.API_RETRIVE_ERROR
    }));

    yield put(getExamSeriesError()) 
  }
}
